import { api, guard, unwrap } from './client'

/**
 * Account endpoints.
 *
 * Note what is missing: anything that reads or writes a token. The session is delivered as
 * an httpOnly cookie the browser attaches automatically, so there is no credential in
 * JavaScript for these functions to pass around — and none for an XSS payload to find.
 */
export const authApi = {
  /**
   * Whether this browser already has a session.
   *
   * Deliberately its own endpoint rather than `/me`: "not signed in" is the expected answer
   * at startup, not an error, and a 401 here would make the console noisy and the loading
   * state wrong.
   */
  session: () => guard(async () => (await api.GET('/api/auth/session', {})).data ?? null),
  me: () => guard(async () => unwrap(await api.GET('/api/auth/me', {}))),

  signUp: (body: { email: string; password: string; display_name?: string | null }) =>
    guard(async () => unwrap(await api.POST('/api/auth/signup', { body }))),

  logIn: (body: { email: string; password: string }) =>
    guard(async () => unwrap(await api.POST('/api/auth/login', { body }))),

  logOut: () => guard(async () => unwrap(await api.POST('/api/auth/logout', {}))),
}
